import React from "react";
import PropTypes from "prop-types";
import { BlogSingleListArticle } from "./BlogSingleListArticle";
import { HighlightedArticle } from "./HighlightedArticle";

export const BlogListArticles = props => {
    const { articlesList, pageNumber } = props;

    if (!articlesList || articlesList.length === 0)
        return (
            <div className="container text-center mt-2 mb-2">
                <h2 classname="h2">We couldn't find articles. Try again.</h2>
            </div>
        );

    return (
        <React.Fragment>
            <div className="row card-list">
                {articlesList.map((article, index) => {
                    if (Number(pageNumber) === 1 && index === 0) {
                        return (
                            <HighlightedArticle
                                key={article.uid}
                                title={article.title}
                                background={article.big_img}
                                description={article.short_description}
                                category={article.category}
                                buttons={[
                                    {
                                        label: "Read More",
                                        url: `/blog/${article.uid}`
                                    }
                                ]}
                                is_on_portal={article.is_on_portal}
                            />
                        );
                    } else {
                        return (
                            <BlogSingleListArticle
                                key={article.uid}
                                uid={article.uid}
                                title={article.title}
                                date={article.date}
                                short_description={article.short_description}
                                small_img={article.small_img}
                                alternative_text_image={article.alternative_text_image}
                                category={article.category}
                                is_on_portal={article.is_on_portal}
                            />
                        );
                    }
                })}
            </div>
        </React.Fragment>
    );
};

BlogListArticles.propTypes = {
    articlesList: PropTypes.arrayOf(PropTypes.shape({
        alternative_text_image: PropTypes.string,
        big_img: PropTypes.string,
        category: PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string
        }),
        date: PropTypes.string,
        short_description: PropTypes.arrayOf(PropTypes.object),
        small_img: PropTypes.string,
        title: PropTypes.string,
        uid: PropTypes.string
    }))
};



// WEBPACK FOOTER //
// src/client/components/site/features/blogs/BlogListArticles.js